module.exports = __webpack_public_path__ + "img/lock-nuki.48b06fb3.png";